<template>
	<el-row :gutter="10" style="background: #f0f3f5;height:100%;">
		<el-col :span="5" class="left_box">
			<el-card style="border-right: 1px solid #ebeef5; height: 100%;background: #ffffff;">
				<div class="phone-list-tabs">
					<button type="button" :class="{ active: phoneListTab === 'all' }" @click="switchPhoneListTab('all')">全部</button>
					<button type="button" :class="{ active: phoneListTab === 'group' }" @click="switchPhoneListTab('group')">分组</button>
				</div>
				<div v-if="phoneListTab === 'group'" class="group-manage-panel">
					<div class="group-manage-header">
						<div>
							<div class="group-manage-title">{{ selectedInstanceGroup ? selectedInstanceGroup.name : '分组管理' }}</div>
							<div class="group-manage-subtitle">
								{{ selectedInstanceGroup ? `${phoneList.length} 台云机` : `${instanceGroups.length} 个分组` }}
							</div>
						</div>
						<div class="group-manage-actions">
							<el-button v-if="selectedInstanceGroup" size="small" @click="backToGroupList">返回</el-button>
							<el-button v-if="selectedInstanceGroup" size="small" type="primary" @click="openAssignGroupDialog">添加</el-button>
							<el-button v-else size="small" type="primary" @click="openCreateGroupDialog">新建</el-button>
						</div>
					</div>
					<div v-if="!selectedInstanceGroup" class="group-list-panel" v-loading="groupLoading">
						<div
							v-for="group in instanceGroups"
							:key="group.id"
							class="group-list-item"
							@click="selectInstanceGroup(group)"
						>
							<div>
								<div class="group-list-name">{{ group.name }}</div>
								<div class="group-list-count">{{ group.device_count || 0 }} 台云机</div>
							</div>
							<el-icon><ArrowRight /></el-icon>
						</div>
						<div v-if="!instanceGroups.length && !groupLoading" class="group-empty">暂无分组</div>
					</div>
				</div>
				<el-input v-model="search" placeholder="输入云手机名称或ID搜索" clearable @input="Get_search_Phones" />
				<div class="select-all">
					<el-checkbox :model-value="selectAllChecked" :indeterminate="selectIndeterminate"
						@change="toggleSelectAll">
						全选 ({{ selectedDevicesCountInCurrentType }}/{{ phoneList.length }})
					</el-checkbox>
					<el-button type="primary" size="small" :disabled="selectedDevicesCountInCurrentType < 2"
						@click="batchRenew">
						批量续费
					</el-button>
				</div>
				<div v-loading="loading" style="display: flex; flex-direction: column; height: 70vh;">
					<el-scrollbar style="flex: 1; min-height: 0;padding-right: 15px;">
						<el-card v-for="phone in phoneList" :key="phone.id" shadow="hover" class="mt-3"
							style="position: relative; min-height: 80px; padding:10px;border-radius: 15px; cursor: pointer;"
							@click="selectPhone(phone)">
							<div style="width:100%;display: flex;justify-content: space-between;align-items: center;">
								<div style="display: flex;align-items: center;">
									<el-checkbox v-model="phone.checked" @click="selectPhone(phone)"></el-checkbox>
									<div style="font-weight: bold; margin-left: 8px;">
										{{ phone.instance_name || `云机${phone.id}` }}
									</div>
								</div>
								<div>
									<el-button type="primary" size="small"
										:disabled="selectedDevicesCountInCurrentType > 1 || (selectedDevicesCountInCurrentType === 1 && !phone.checked)"
										@click.stop="renewPhone(phone)">续费</el-button>
								</div>
							</div>
							<div
								style="display: flex;justify-content: space-between;width: 100%;align-items: center;margin-bottom: 4px;">
								<div style="color: #909399;">ID: {{ phone.instances.name }}</div>
							</div>
							<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;">
								<div :style="{ color: getRemainingDaysColor(phone) }">
									<CountdownComponent :expireTime="phone.expire_time" :is_trial="phone.is_trial" />
								</div>
							</div>
						</el-card>
					</el-scrollbar>
				</div>
			</el-card>
		</el-col>
		<el-col :span="19" style="background: #f0f3f5;padding:0">
			<el-card style="border-left: 1px solid #ebeef5; height: 100%;background: #ffffff">
				<div class="top-right-buttons" style="margin-bottom: 10px;">
					<el-checkbox :model-value="selectAllChecked_right" :indeterminate="selectIndeterminate_right"
						@change="toggleSelectAll_right">
						全选 ({{ selectedDevicesCountInCurrentType2 }}/{{ phoneList.length }})
					</el-checkbox>
					<div>
						<el-popover placement="bottom" trigger="click" popper-style="padding:0;">
							<template #reference>
								<el-button type="primary">批量操作</el-button>
							</template>
							<div class="fun_options">
								<p @click="restart_All_Phone">重启</p>
								<p @click="reset_All_Phone">重置</p>
								<p @click="shutdown_All_Phone">一键新机</p>
								<p @click="android_classify_phone">更换机型</p>
							</div>
						</el-popover>
						<el-button @click.stop="router.push('/groupControl')">云机群控</el-button>
					</div>
				</div>
				<el-scrollbar height="78vh">
					<el-row class="main_container">
						<el-col v-for="phone in previewPhoneList" :key="phone.id" :span="2">
							<div class="compact-rectangle">
								<div
									style="display: flex;flex-direction: column;height: 100%;width:100%;position: relative;padding-bottom: 20px;">
									<div style="display: flex;align-items: center;justify-content: space-between;width:100%;height: 20px;"
										@click.stop="selectPhone_right(phone)">
										<el-checkbox v-model="phone.checked"
											@click="selectPhone_right(phone)"></el-checkbox>
										<div class="phone_name_box" @click.stop>
											<el-icon style="margin: 0 10px;" @click="edit_phone_name(phone)">
												<Edit />
											</el-icon>
											<input v-if="phone.edit_name_checked" v-model="phone.instance_name"
												:class="`phoneInput_${phone.id}`"
												@blur="enter_edit_phone_name(phone,'blur')"
												@keydown.enter="enter_edit_phone_name(phone,'enter')" />
											<el-popover :content="phone.instance_name" placement="top"
												popper-style="padding:0;width:initial;min-width:initial;">
												<template #reference>
													<span
														style="display: inline-block; width: 72%;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
														v-if="!phone.edit_name_checked">{{ phone.instance_name || `云机${phone.id}` }}</span>
												</template>
											</el-popover>
										</div>
									</div>
									<div class="compact-image-container" v-loading="phone.screen_shot_loading"
										:element-loading-text="rtcLoadingText(phone.instances?.rtc_status)" element-loading-background="rgba(0, 0, 0, 0.5)"
										@click="showPhoneOverlay(phone)"
										@contextmenu.prevent="handlePhoneContextMenu($event, phone)">
										<img v-if="phone.preview_image" style="max-width: 100%; max-height: 100%;"
											:src="phone.preview_image" alt="预览图" @error="handleImageError">
										<img v-else src="@/assets/phone_no_bg2.png" alt="Logo"
											style="max-width: 100%; max-height: 100%;">
									</div>
									<div class="phone-android-version-view">
										<div><img src="@/assets/android-head_flat.png" />{{phone.image_tag}}</div>
										<div>{{phone.instances?.real_phone_template?.brand}}</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="compact-rectangle" @click="addNewPhone">
								<div class="compact-image-container">
									<div
										style="display: flex;flex-direction: column;align-items:center;align-content: center;">
										<el-icon :size="20">
											<CirclePlus />
										</el-icon>
										<span>新增云手机</span>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</el-scrollbar>
			</el-card>
		</el-col>
		<!-- 群体更换机型的弹窗 -->
		<el-dialog v-model="change_phone_model_visible" width="500" title="设备列表">
			<div class="android-tabs-header">
				<div v-for="(item, index) in android_classify_phone_list" :key="index" class="android-tab-item"
					:class="{ active: current_android_version == item.android_version }"
					@click="change_phone_model_dialog_show(item)">Android {{ item.android_version }}
				</div>
			</div>
			<el-table ref="phoneTableRef" :data="current_android_phone_tableData" style="width: 100%"
				@selection-change="handleSelectionChange" :row-key="getRowKey">
				<el-table-column type="selection" width="55" />
				<el-table-column property="instance_name" label="云机名称"></el-table-column>
				<el-table-column property="instances.real_phone_template.brand" label="品牌"></el-table-column>
				<el-table-column property="instances.real_phone_template.model" label="机型"></el-table-column>
			</el-table>
			<div style="margin-top: 10px;" class="flex_between_center">
				<label style="white-space: nowrap;margin-right: 10px;">产品品牌</label>
				<el-select v-model="select_brand_value" placeholder="请选择产品品牌" @change="select_brands">
					<el-option v-for="item in phone_type_list" :key="item.brand" :label="item.brand"
						:value="item.brand" />
				</el-select>
				<label style="white-space: nowrap;margin:0 10px;">云机机型</label>
				<el-select v-model="select_model_value" placeholder="请选择云机机型" :disabled="!select_brand_value">
					<el-option v-for="item in select_model_list" :key="item.id" :label="item.model" :value="item.id" />
				</el-select>
			</div>
			<div style="text-align: left;"><el-checkbox label="重置云机数据" v-model="reset_phone_data_checked" /></div>
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="check_All_phone_type">更换机型</el-button>
					<el-button @click="change_phone_model_visible = false">取消</el-button>
				</div>
			</template>
		</el-dialog>
		<el-dialog v-model="create_group_visible" width="360" title="新建分组">
			<el-input v-model="create_group_name" maxlength="20" show-word-limit placeholder="请输入分组名称" />
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="create_group_visible = false">取消</el-button>
					<el-button type="primary" :loading="create_group_loading" @click="createInstanceGroup">确定</el-button>
				</div>
			</template>
		</el-dialog>
		<el-dialog v-model="assign_group_visible" width="520" title="添加设备到分组">
			<div class="assign-group-tip">添加到：{{ selectedInstanceGroup?.name || '-' }}</div>
			<div class="assign-group-toolbar">
				<el-button size="small" @click="toggleAllGroupCandidates">
					{{ isAllGroupCandidatesChecked ? '取消全选' : '全选' }}
				</el-button>
			</div>
			<div class="assign-group-list" v-loading="assign_group_loading">
				<div
					v-for="item in groupCandidatePhones"
					:key="item.id"
					class="assign-group-item"
					@click="item.checked = !item.checked"
				>
					<el-checkbox :model-value="item.checked" @click.stop="item.checked = !item.checked" />
					<div class="assign-group-info">
						<div class="assign-group-name">{{ item.instance_name || item.instances?.name || `云机${item.id}` }}</div>
						<div class="assign-group-desc">当前分组：{{ item.current_group_name || '未分组' }}</div>
					</div>
				</div>
				<div v-if="!groupCandidatePhones.length && !assign_group_loading" class="group-empty">暂无可添加的云机</div>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="assign_group_visible = false">取消</el-button>
					<el-button type="primary" :loading="assign_group_submit_loading" @click="assignPhonesToGroup">确定添加</el-button>
				</div>
			</template>
		</el-dialog>
		<transition name="slide-fade">
			<div v-show="showOverlay" class="overlay-mask">
				<div class="overlay-container" :style="{ width: elementWidth}">
					<el-icon class="close-icon" @click="closeOverlay(false)">
						<Close />
					</el-icon>
					<div class="overlay-content">
						<input id="ime" ref="imeRef" style="position:absolute; top:0px;opacity: 0;"
							:readOnly="!store.state.Phone_Local_keyboard_flag" />
						<input id="ime2" ref="imeRef2" style="position:absolute; top:0px;opacity: 0;"
							:readOnly="store.state.Phone_Local_keyboard_flag" />

						<div v-if="currentPhone.id" class="phone-display" v-loading="restartPhone_loading"
							:element-loading-text="restartPhone_loading_text"
							element-loading-background="rgba(0, 0, 0, 0.7)" @mouseover="hoverdada">
							<div @click="imeRef_focus"
								:id="`phone-display-${currentPhone.instances.machine.ip}:${currentPhone.instances.adb_port}`"
								class="master-phone-view">
							</div>
							<el-button v-if="showInfoToggle" class="info-toggle-btn" type="primary" circle
								@click="showInfoPanel = !showInfoPanel">
								<el-icon>
									<component :is="showInfoPanel ? ArrowRight : ArrowLeft" />
								</el-icon>
							</el-button>
						</div>
						<div class="phone-info" :class="{ 'hidden': !showInfoPanel }"
							:style="{ display:elementWidthflag==true?'block':'none' }">
							<h3 style="margin-top: 0">云机详细信息</h3>
							<div class="info-container">
								<div class="info-row">
									<span class="info-label">云机名称</span>
									<span
										class="info-value">{{ currentPhone.instance_name || `云机${currentPhone.id}` }}</span>
								</div>
								<div class="info-row">
									<span class="info-label">云机品牌机型</span>
									<span
										class="info-value">{{ currentPhone.instances?.real_phone_template?.brand }}&nbsp;{{currentPhone.instances?.real_phone_template?.model}}</span>
								</div>
								<div class="info-row">
									<span class="info-label">云机ID</span>
									<span class="info-value">{{ currentPhone.instances?.name || '-' }}</span>
								</div>
								<div class="info-row">
									<span class="info-label">到期时间</span>
									<span class="info-value">{{ formatDate(currentPhone.expire_time) }}</span>
								</div>
								<div class="info-row">
									<span class="info-label">剩余天数</span>
									<span class="info-value">
										<CountdownComponent :expireTime="currentPhone.expire_time"
											:is_trial="currentPhone.is_trial" />
									</span>
								</div>
								<div class="info-row">
									<span class="info-label">运行状态</span>
									<span class="info-value">
										<span class="status-tag"
											:class="rtcStatusClass(currentPhone.instances?.rtc_status)">
											{{ rtcStatusText(currentPhone.instances?.rtc_status) }}
										</span>
									</span>
								</div>
								<div class="info-row">
									<span class="info-label">配置信息</span>
									<span class="info-value">
										{{ currentPhone.instances?.cpu_cores || '-' }}核
										{{ (currentPhone.instances?.memory / 1024).toFixed(0) || 0 }}G运存
										{{ currentPhone.instances?.storage || '-' }}G存储
									</span>
								</div>
								<div class="action-row">
									<el-popover ref="phone_type_popoverRef" placement="left" trigger="click"
										width="auto">
										<template #reference>
											<el-button plain round v-if="currentPhone.instances?.is_realphone==1"
												type="primary" @click="change_phone_type('single')">更换机型</el-button>
										</template>
										<template #default>
											<el-cascader-panel v-model="cascader_value" :options="phone_type_list"
												:props="props" @change="check_phone_type" />
										</template>
									</el-popover>
									<el-button plain round type="warning" @click="restartPhone">重启</el-button>
									<el-button plain round type="danger" @click="resetPhone">重置</el-button>
									<el-button plain round type="success" @click="shutdownPhone">一键新机</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<PhoneContextMenu
			ref="contextMenuRef"
			@restart="handleContextRestart"
			@reset="handleContextReset"
			@oneKeyNew="handleContextOneKeyNew"
			@changeModel="handleContextChangeModel"
			@transfer="handleContextTransfer"
		/>
		<PhoneTransferDialog ref="transferDialogRef" />
		<PhoneChangeModelDialog ref="changeModelDialogRef" @changed="fetchPhoneList" />
	</el-row>
</template>

<script setup lang="ts">
	type Machine = {
		id : number;
		ip : string;
		cpu : string;
		cpu_core : number;
		memory : number;
		volume : number;
		status : number;
		created_at : string;
		updated_at : string;
		mac_addr : string;
		volume_device : string;
	};
	type Real_phone_template = {
		brand : string;
		model : string;
	}
	type Instance = {
		id : number;
		machine_id : number;
		mac : string;
		ip : string;
		product_id : number;
		package_id : number;
		created_at : string;
		updated_at : string;
		status : number;
		is_realphone : number;
		adb_port : number;
		adb_address : string;
		height : number;
		width : number;
		image : string;
		image_tag : string;
		index : number;
		state : number;
		rtc_status : number;
		cpu_cores : number;
		memory : number;
		storage : number;
		name : string;
		machine : Machine;
		real_phone_template : Real_phone_template;
	};

	type Phone = {
		id : number;
		user_id : string;
		instance_id : number;
		start_time : string;
		expire_time : string;
		status : number;
		created_at : string;
		updated_at : string;
		order_id : number;
		image : string;
		image_tag : string;
		auto_renew : number;
		screen_shot : string;
		instance_name : string;
		instances : Instance;
		is_trial ?: number;
		state : number;
		checked ?: boolean;
		edit_name_checked ?: boolean;
		preview_image : string;
		screen_shot_loading ?: boolean;
	};

	// 修复点3：定义 PhoneBrand 和 ModelOption 类型，明确结构
	interface ModelOption {
		id : number | string;
		model : string;
		[key : string] : any; // 兼容其他属性
	}

	interface PhoneBrand {
		brand : string;
		models : ModelOption[]; // 明确 models 是 ModelOption 数组
	}
	// 新增：安卓版本分组类型
	interface AndroidVersionGroup {
		android_version : string;
		phones_arr : Phone[];
	}
	type PhoneListTab = 'all' | 'group';
	interface InstanceGroup {
		id : number;
		name : string;
		device_count ?: number;
	}
	type GroupCandidatePhone = Phone & {
		current_group_id ?: number | string;
		current_group_name ?: string;
		checked ?: boolean;
	};
	import { useRouter } from 'vue-router';
	const router = useRouter();
	import '../style/app.css';
	import defaultImage from '@/assets/phone_no_bg2.png';
	import { ref, Ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
	import { Close, CirclePlus, ArrowRight, ArrowLeft, Edit } from '@element-plus/icons-vue'; // 补充导入 Edit 图标
	import { StreamClientScrcpy } from '@/app/googDevice/client/StreamClientScrcpy';
	import { openCloudPhoneStream, type CloudPhoneStreamClient } from '@/app/streaming/openCloudPhoneStream';
	import CountdownComponent from '@/components/CountdownComponent.vue';
	import { KeyInputHandler, type KeyEventListener } from '@/app/googDevice/KeyInputHandler';
	import { CommandControlMessage } from '@/app/controlMessage/CommandControlMessage'
	import { ElMessage, ElMessageBox } from 'element-plus';
	import request from '@/utils';
	import { useStore } from 'vuex';
	import type { PopoverInstance } from 'element-plus'
	import PhoneContextMenu from '@/components/PhoneContextMenu.vue';
	import PhoneTransferDialog from '@/components/PhoneTransferDialog.vue';
	import PhoneChangeModelDialog from '@/components/PhoneChangeModelDialog.vue';
	import { eventBus } from '@/utils/eventBus';
	const phone_type_popoverRef = ref<PopoverInstance>()
	const contextMenuRef = ref<InstanceType<typeof PhoneContextMenu>>();
	const transferDialogRef = ref<InstanceType<typeof PhoneTransferDialog>>();
	const changeModelDialogRef = ref<InstanceType<typeof PhoneChangeModelDialog>>();
	const store = useStore();
	const elementWidth = ref('auto');
	const elementWidthflag = ref(true);
	const search = ref('');
	const phoneListTab = ref<PhoneListTab>('all');
	const viewMode = ref('card');
	const showOverlay = ref(false);
	const showInfoPanel = ref(true);
	const windowWidth = ref(window.innerWidth);
	const loading = ref(false);
	const restartPhone_loading = ref(false);
	const restartPhone_loading_text = ref('云手机重启中,请稍等');
	const phoneList = ref<Phone[]>([]);
	const previewPhoneList = ref<Phone[]>([]);
	const No_change_phone_list = ref<Phone[]>([]);
	const filter_phone_type_list = ref<Phone[]>([]);
	const Phone_selectedMap = ref(new Map<number, boolean>());
	const Phone_selectedMap_right = ref(new Map<number, boolean>());
	const currentPhone = ref<Phone>({} as Phone);
	const hash = location.hash.replace(/^#!/, '');
	const parsedQuery = new URLSearchParams(hash);
	const selectAllChecked = ref(false);
	const selectAllChecked_right = ref(false);
	const selectIndeterminate = ref(false);
	const selectIndeterminate_right = ref(false);
	const close_out : any = ref(null);
	const enter_change_flag : any = ref(false);
	const select_brand_value = ref('');//群体更改云机弹窗选中的品牌
	const select_model_value = ref(''); //群体更改云机弹窗选中的机型
	const select_model_list = ref<ModelOption[]>([]);
	const android_classify_phone_list = ref<AndroidVersionGroup[]>([]);
	const android_selectedPhones = ref<Phone[]>([]); //更换机型弹窗根据安卓版本选中的云手机列表数据
	const change_phone_model_visible : any = ref(false); //群体更改云手机机型弹窗开关
	const current_android_version : any = ref(null); //当前群体更改云机机型弹窗时当前的tabs安卓版本
	const phoneTableRef = ref<any>(null); //当前更改云机机型弹窗里table ref
	const current_android_phone_tableData : any = ref(false);
	const reset_phone_data_checked : any = ref(false);
	const instanceGroups = ref<InstanceGroup[]>([]);
	const selectedInstanceGroup = ref<InstanceGroup | null>(null);
	const groupLoading = ref(false);
	const create_group_visible = ref(false);
	const create_group_name = ref('');
	const create_group_loading = ref(false);
	const assign_group_visible = ref(false);
	const assign_group_loading = ref(false);
	const assign_group_submit_loading = ref(false);
	const groupCandidatePhones = ref<GroupCandidatePhone[]>([]);
	const warningMessage : any = ref(null);
	const ws : Ref<WebSocket | null> = ref(null);
	const StreamClientScrcpy_start : Ref<CloudPhoneStreamClient | null> = ref(null);
	const cascader_value = ref([]);
	const loading_phone_info : any = ref(null);
	const phone_type_list = ref<PhoneBrand[]>([]); // 现在使用定义好的 PhoneBrand 类型
	const phone_type_cascader_show = ref(false);
	const fetchPhoneList_Interval = ref<NodeJS.Timeout | null>(null)
	const IsEnglish_Or_Chinese_input = ref(true);
	const props = { label: 'model', value: 'id', children: 'models' };
	const selectedDevicesCountInCurrentType = computed(() => phoneList.value.filter(phone => phone.checked).length);
	const selectedDevicesCountInCurrentType2 = computed(() => previewPhoneList.value.filter(phone => phone.checked).length);
	const handleImageError = (e : any) => {
		const target = e.target as HTMLImageElement;
		target.src = defaultImage;
	};
	const filteredDevices = computed(() => phoneList.value);
	const toggleSelectAll = (val : boolean) => {
		phoneList.value.forEach(phone => {
			phone.checked = val;
			Phone_selectedMap.value.set(phone.id, val);
		});
		selectAllChecked.value = val;
		selectIndeterminate.value = false;
	};
	const toggleSelectAll_right = (val : boolean) => {
		previewPhoneList.value.forEach(phone => {
			phone.checked = val;
			Phone_selectedMap_right.value.set(phone.id, val);
		});
		selectIndeterminate_right.value = false;
		selectAllChecked_right.value = val;
	};

	watch(phoneList, (newVal) => {
		if (newVal.length === 0) {
			selectAllChecked.value = false;
			selectIndeterminate.value = false;
			return;
		}
		const checkedCount = newVal.filter(phone => phone.checked).length;
		selectAllChecked.value = checkedCount === newVal.length;
		selectIndeterminate.value = checkedCount > 0 && checkedCount < newVal.length;
	}, { deep: true });

	watch(previewPhoneList, (newVal) => {
		if (newVal.length === 0) {
			selectAllChecked_right.value = false;
			selectIndeterminate_right.value = false;
			return;
		}
		const checkedCount = newVal.filter(phone => phone.checked).length;
		selectAllChecked_right.value = checkedCount === newVal.length;
		selectIndeterminate_right.value = checkedCount > 0 && checkedCount < newVal.length;
	}, { deep: true });

	const Get_search_Phones = () => {
		phoneList.value = filteredPhones.value;
	};

	const filteredPhones = computed(() => {
		const searchTerm = search.value.toLowerCase();
		return No_change_phone_list.value.filter(phone => {
			const hasInstanceName = phone.instance_name && phone.instance_name.toLowerCase().includes(searchTerm);
			const hasInstancesName = phone.instances && phone.instances.name && phone.instances.name.toLowerCase().includes(searchTerm);
			return hasInstanceName || hasInstancesName;
		});
	});
	const isAllGroupCandidatesChecked = computed(() =>
		groupCandidatePhones.value.length > 0 && groupCandidatePhones.value.every(item => item.checked)
	);

	const selectedPhones = computed(() => phoneList.value.filter(phone => phone.checked));
	const showInfoToggle = computed(() => windowWidth.value < 800);

	interface ApiResponse<T = any> {
		code : number;
		msg : string;
		data : T;
	}
	const fetchCurrentPhoneSource = async () : Promise<Phone[]> => {
		if (phoneListTab.value === 'group') {
			if (!selectedInstanceGroup.value) {
				return [];
			}
			const response = await request.get<ApiResponse<Phone[]>>('/instance_groups/devices', {
				params: { group_id: selectedInstanceGroup.value.id }
			});
			if (response.data.code !== 200) {
				ElMessage.error(response.data.msg || '获取分组云机列表失败');
				return [];
			}
			return response.data.data || [];
		}
		const response = await request.get<ApiResponse<Phone[]>>('/containers/list');
		if (response.data.code !== 200) {
			ElMessage.error(response.data.msg || '获取云手机列表失败');
			return [];
		}
		return response.data.data || [];
	};
	//获取云手机列表数据
	const fetchPhoneList = async () => {
		try {
			loading.value = true;
			if (phoneListTab.value === 'group') {
				const phones = await fetchCurrentPhoneSource();
				No_change_phone_list.value = phones.map(phone => ({
					...phone,
					checked: Phone_selectedMap.value.get(phone.id) ?? false,
					screen_shot_loading: phone.instances?.rtc_status !== 1
				}));
				phoneList.value = filteredPhones.value;
				previewPhoneList.value = phones.map(phone => ({
					...phone,
					checked: Phone_selectedMap_right.value.get(phone.id) ?? false,
					edit_name_checked: false,
					preview_image: buildPreviewImageUrl(phone.screen_shot),
					screen_shot_loading: phone.instances?.rtc_status !== 1
				}));
				return;
			}
			const response = await request.get<ApiResponse<Phone[]>>('/containers/list');
			if (response.data.code === 200) {
				No_change_phone_list.value = response.data.data.map(phone => ({
					...phone,
					checked: false,
					screen_shot_loading: phone.instances?.rtc_status !== 1
				}));
				phoneList.value = filteredPhones.value;
				previewPhoneList.value = response.data.data.map(phone => ({
					...phone,
					checked: Phone_selectedMap_right.value.get(phone.id) ?? false,
					edit_name_checked: false,
					preview_image: phone.screen_shot.includes('http') ? phone.screen_shot + `?timestamp=${Date.now()}` : store.state.request_url + phone.screen_shot + `?timestamp=${Date.now()}`,
					screen_shot_loading: phone.instances?.rtc_status !== 1
				}));
			} else {
				ElMessage.error(response.data.msg || '获取云手机列表失败');
			}
		} catch (error) { } finally {
			loading.value = false;
		}
	};

	// 列表静默刷新（10s 轮询）：不触发 loading 遮罩，按 id 原地合并，仅当 screen_shot 路径变化时才换新的 preview_image URL，避免 <img> 闪烁重载
	const fetchInstanceGroups = async () => {
		try {
			groupLoading.value = true;
			const response = await request.get<ApiResponse<InstanceGroup[]>>('/instance_groups/list');
			if (response.data.code === 200) {
				instanceGroups.value = response.data.data || [];
				if (selectedInstanceGroup.value) {
					const latest = instanceGroups.value.find(item => item.id === selectedInstanceGroup.value?.id);
					if (latest) {
						selectedInstanceGroup.value = latest;
					} else {
						selectedInstanceGroup.value = null;
						No_change_phone_list.value = [];
						phoneList.value = [];
						previewPhoneList.value = [];
					}
				}
			} else {
				ElMessage.error(response.data.msg || '获取云机分组失败');
			}
		} catch (error) {
			console.error('获取云机分组失败:', error);
		} finally {
			groupLoading.value = false;
		}
	};

	const switchPhoneListTab = async (tab : PhoneListTab) => {
		if (phoneListTab.value === tab) return;
		phoneListTab.value = tab;
		search.value = '';
		Phone_selectedMap.value.clear();
		Phone_selectedMap_right.value.clear();
		if (tab === 'all') {
			selectedInstanceGroup.value = null;
			await fetchPhoneList();
			return;
		}
		await fetchInstanceGroups();
		No_change_phone_list.value = [];
		phoneList.value = [];
		previewPhoneList.value = [];
	};

	const selectInstanceGroup = async (group : InstanceGroup) => {
		selectedInstanceGroup.value = group;
		search.value = '';
		Phone_selectedMap.value.clear();
		Phone_selectedMap_right.value.clear();
		await fetchPhoneList();
	};

	const backToGroupList = async () => {
		selectedInstanceGroup.value = null;
		search.value = '';
		No_change_phone_list.value = [];
		phoneList.value = [];
		previewPhoneList.value = [];
		await fetchInstanceGroups();
	};

	const openCreateGroupDialog = () => {
		create_group_name.value = '';
		create_group_visible.value = true;
	};

	const createInstanceGroup = async () => {
		const name = create_group_name.value.trim();
		if (!name) {
			ElMessage.warning('请输入分组名称');
			return;
		}
		try {
			create_group_loading.value = true;
			const response = await request.post('/instance_groups/create', { name });
			if (response.data.code === 200) {
				ElMessage.success('创建分组成功');
				create_group_visible.value = false;
				await fetchInstanceGroups();
			} else {
				ElMessage.error(response.data.msg || '创建分组失败');
			}
		} finally {
			create_group_loading.value = false;
		}
	};

	const openAssignGroupDialog = async () => {
		if (!selectedInstanceGroup.value) return;
		assign_group_visible.value = true;
		assign_group_loading.value = true;
		try {
			const response = await request.get<ApiResponse<GroupCandidatePhone[]>>('/instance_groups/candidates', {
				params: { group_id: selectedInstanceGroup.value.id }
			});
			const groupId = selectedInstanceGroup.value.id;
			groupCandidatePhones.value = (response.data.data || [])
				.filter(item => Number(item.current_group_id || 0) !== groupId)
				.map(item => ({ ...item, checked: false }));
		} catch (error) {
			console.error('获取可添加云机失败:', error);
		} finally {
			assign_group_loading.value = false;
		}
	};

	const toggleAllGroupCandidates = () => {
		const nextChecked = !isAllGroupCandidatesChecked.value;
		groupCandidatePhones.value = groupCandidatePhones.value.map(item => ({ ...item, checked: nextChecked }));
	};

	const assignPhonesToGroup = async () => {
		if (!selectedInstanceGroup.value) return;
		const selected = groupCandidatePhones.value.filter(item => item.checked);
		if (!selected.length) {
			ElMessage.warning('请先选择云机');
			return;
		}
		try {
			assign_group_submit_loading.value = true;
			const response = await request.post('/instance_groups/assign', {
				group_id: selectedInstanceGroup.value.id,
				instance_use_ids: selected.map(item => item.id)
			});
			if (response.data.code === 200) {
				ElMessage.success('添加设备成功');
				assign_group_visible.value = false;
				await fetchInstanceGroups();
				await fetchPhoneList();
			} else {
				ElMessage.error(response.data.msg || '添加设备失败');
			}
		} finally {
			assign_group_submit_loading.value = false;
		}
	};

	const silentRefreshPending = ref(false);
	const buildPreviewImageUrl = (screenShot : string | undefined) : string => {
		if (!screenShot) return '';
		const ts = Date.now();
		return screenShot.includes('http')
			? `${screenShot}?timestamp=${ts}`
			: `${store.state.request_url}${screenShot}?timestamp=${ts}`;
	};
	const mergePhoneListSilently = (incoming : Phone[]) => {
		const prevMain = new Map<number, Phone>();
		No_change_phone_list.value.forEach(p => prevMain.set(p.id, p));
		const prevPreview = new Map<number, Phone>();
		previewPhoneList.value.forEach(p => prevPreview.set(p.id, p));

		const nextMain : Phone[] = incoming.map(p => {
			const prev = prevMain.get(p.id);
			return {
				...p,
				checked: Phone_selectedMap.value.get(p.id) ?? prev?.checked ?? false,
				edit_name_checked: prev?.edit_name_checked ?? false,
				preview_image: prev?.preview_image ?? '',
				screen_shot_loading: p.instances?.rtc_status !== 1,
			};
		});
		const nextPreview : Phone[] = incoming.map(p => {
			const prev = prevPreview.get(p.id);
			const sameShot = !!prev && prev.screen_shot === p.screen_shot && !!prev.preview_image;
			return {
				...p,
				checked: Phone_selectedMap_right.value.get(p.id) ?? prev?.checked ?? false,
				edit_name_checked: prev?.edit_name_checked ?? false,
				preview_image: sameShot ? prev!.preview_image : buildPreviewImageUrl(p.screen_shot),
				screen_shot_loading: p.instances?.rtc_status !== 1,
			};
		});
		No_change_phone_list.value = nextMain;
		phoneList.value = filteredPhones.value;
		previewPhoneList.value = nextPreview;
	};
	const silentRefreshPhoneList = async () => {
		if (silentRefreshPending.value) return;
		silentRefreshPending.value = true;
		try {
			if (phoneListTab.value === 'group') {
				const phones = await fetchCurrentPhoneSource();
				mergePhoneListSilently(phones);
				return;
			}
			const response = await request.get<ApiResponse<Phone[]>>('/containers/list');
			if (response.data.code === 200 && Array.isArray(response.data.data)) {
				mergePhoneListSilently(response.data.data);
			}
		} catch (_e) {
			// 静默失败，不提示
		} finally {
			silentRefreshPending.value = false;
		}
	};
	const startPhoneListPolling = () => {
		if (fetchPhoneList_Interval.value) return;
		fetchPhoneList_Interval.value = setInterval(silentRefreshPhoneList, 10_000);
	};
	const stopPhoneListPolling = () => {
		if (fetchPhoneList_Interval.value) {
			clearInterval(fetchPhoneList_Interval.value);
			fetchPhoneList_Interval.value = null;
		}
	};
	//修改云机名称
	const edit_phone_name = async (phone_data : any) => {
		phone_data.edit_name_checked = !phone_data.edit_name_checked
		await nextTick();
		const inputSelector = `.phoneInput_${phone_data.id}`;
		const inputEl = document.querySelector<HTMLInputElement>(inputSelector);
		if (phone_data.edit_name_checked == false) {
			enter_edit_phone_name(phone_data, 'enter')
		} else {
			inputEl?.focus()
		}
	};
	//回车或者失焦修改名称
	const enter_edit_phone_name = (phone_data : any, type : any) => {
		if (type == 'enter') {
			enter_change_flag.value = true
		} else {
			if (enter_change_flag.value == true) {
				enter_change_flag.value = false
				return;
			} else {
				enter_change_flag.value = false
			}
		}
		if (phone_data.instance_name.length > 10) {
			ElMessage.warning('云机名称最多不能超过10个字符');
		} else {
			const requestData = { instance_use_id: phone_data.id, name: phone_data.instance_name };
			const response = request.post('/instance/rename', requestData);
			response.then((res) => {
				if (res.data.code == 200) {
					phone_data.edit_name_checked = false
					ElMessage.success('修改云机名称成功');
				}
			})
		}
	};
	const getRemainingDaysColor = (phone : any) : string => {
		// 修复点5：修正属性名（expire_time 而非 expireTime）
		const expireDate = new Date(phone.expire_time);
		const now = new Date();
		const diffTime = expireDate.getTime() - now.getTime();
		const days = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
		if (days <= 1) return 'red';
		if (days <= 3) return 'orange';
		return '#909399';
	};

	const formatDate = (dateString : string) : string => {
		if (!dateString) return '';
		const date = new Date(dateString);
		if (isNaN(date.getTime())) return 'Invalid Date';
		return date.toLocaleString('zh-CN', {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
			timeZone: 'Asia/Shanghai'
		}).replace(/\//g, '-');
	};

	const isSingleSelected = (phone : Phone) => selectedDevicesCountInCurrentType.value === 1 && phone.checked;

	// 根据 rtc_status 获取云机运行状态文本：0=离线 1=在线 2=重启中
	const rtcStatusText = (rtcStatus ?: number) : string => {
		switch (rtcStatus ?? 0) {
			case 1: return '运行中';
			case 2: return '重启中';
			case 0:
			default: return '设备已离线';
		}
	};
	const rtcStatusClass = (rtcStatus ?: number) : string => {
		switch (rtcStatus ?? 0) {
			case 1: return 'running';
			case 2: return 'restarting';
			case 0:
			default: return 'offline';
		}
	};
	// 云机卡片 v-loading 的提示文案：0=离线 2=重启中
	const rtcLoadingText = (rtcStatus ?: number) : string => {
		switch (rtcStatus ?? 0) {
			case 2: return '重启中,请稍等';
			case 0:
			default: return '设备已离线';
		}
	};

	const selectPhone = (phone : Phone) => {
		phone.checked = !phone.checked;
		Phone_selectedMap.value.set(phone.id, !phone.checked);
	};

	const selectPhone_right = (phone : Phone) => {
		phone.checked = !phone.checked;
		Phone_selectedMap_right.value.set(phone.id, !phone.checked);
	};
	const showPhoneOverlay = async (phone : any) => {
		await new Promise<void>((resolve) => {
			currentPhone.value = phone;
			resolve();
		});
		const index = previewPhoneList.value.findIndex(item => item.id === phone.id);
		const rtcStatus = phone.instances?.rtc_status ?? 0;
		if (rtcStatus == 2) {
			previewPhoneList.value[index].screen_shot_loading = true;
			ElMessage.warning('该云手机正在重启中，请稍后');
		} else if (rtcStatus == 1) {
			initPhone(phone, 800);
		} else {
			previewPhoneList.value[index].screen_shot_loading = false;
			ElMessage.error('该云手机目前处于离线状态');
		}
		showInfoPanel.value = windowWidth.value >= 800;
	};

	const isUserActive = ref(true);
	const hoverdada = () => {
		if (restartPhone_loading_text.value == '断流待机中' && restartPhone_loading.value) {
			close_out.value = null;
			restartPhone_loading.value = false;
			initPhone(currentPhone.value, 800);
		}
	};

	const handleActivityChange = (active : boolean) => {
		isUserActive.value = active;
		if (!active) {
			restartPhone_loading.value = true;
			restartPhone_loading_text.value = '断流待机中';
			closeOverlay(true);
		}
	};

	watch(() => store.state.Horizontal_screen, (newvalue) => {
		if (newvalue) {
			document.documentElement.style.setProperty('--zoomsize', '0.8');
		} else {
			document.documentElement.style.setProperty('--zoomsize', `${setCloudPhoneZoom()}`);
		}
	});

	const initPhone = async (phone : any, time : any) => {
		if (!phone.instances.machine || !phone.instances.adb_port) {
			ElMessage.error('该云手机实例信息不完整');
			return;
		}
		const udid = `${phone.instances.machine.ip}:${phone.instances.adb_port}`;
		try {
			StreamClientScrcpy_start.value = await openCloudPhoneStream({
				phone,
				showToolBox: true,
				isMasterCloud: true,
				sourceType: 'single',
			});
		} catch (error) {
			console.error('[initPhone] 创建云手机流客户端失败', error);
			ElMessage.error('该云手机实例生成出错,不存在该云机实例');
			return;
		}
		StreamClientScrcpy_start.value.setIdleThreshold(240000);
		StreamClientScrcpy_start.value.addActivityListener(handleActivityChange);
		const player = StreamClientScrcpy_start.value?.getPlayer();
		if (StreamClientScrcpy_start.value?.mode === 'ws_room') {
			try {
				await request.post('/tools/switch_local_keyboard', { udid, type: 'phone' });
			} catch (error) {
				console.error('ws_room 切换 Gboard 失败:', error);
			}
			store.commit('Update_Local_keyboard_flag', true);
			StreamClientScrcpy_start.value?.setHandleKeyboardEvents(true);
		} else {
			const checkbox = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`) as HTMLInputElement | null;
			if (checkbox) {
				checkbox.checked = false;
				checkbox.dispatchEvent(new Event('change'));
			}
			setTimeout(() => {
				if (store.state.Phone_Local_keyboard_flag) {
					const toggleBtn = document.getElementById(`input_capture_keyboard_${udid}_${player?.getName()}`);
					if (toggleBtn) {
						toggleBtn.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true
						}));
					}
				}
			}, 800);
		}
		if (player) {
			setTimeout(() => {
				if (player.videoWidth > player.videoHeight) {
					store.commit('change_screen', true);
					document.documentElement.style.setProperty('--zoomsize', '0.8');
				} else {
					store.commit('change_screen', false);
					document.documentElement.style.setProperty('--zoomsize', `${setCloudPhoneZoom()}`);
				}
				showOverlay.value = true;
			}, time);
			player.touchableCanvas.onclick = () => {
				setTimeout(() => {
					if (!store.state.Horizontal_screen && player.videoWidth > player.videoHeight) {
						store.commit('change_screen', true);
					}
					if (store.state.Horizontal_screen && player.videoWidth < player.videoHeight) {
						store.commit('change_screen', false);
					}
				}, 1000);
			};
		} else {
			ElMessage.error('该云手机实例生成出错,不存在该云机实例');
		}
	};
	//关闭云手机渲染操作弹窗
	const closeOverlay = (flag : any) => {
		if (flag == false) {
			showOverlay.value = false;
			cascader_value.value = [];
		}
		if (ws.value) {
			if (ws.value.readyState === WebSocket.OPEN) {
				ws.value.close(1000, '正常关闭');
			}
			ws.value = null;
		}
		if (StreamClientScrcpy_start.value) {
			warningMessage.value?.close();
			StreamClientScrcpy_start.value.onDisconnected();
			StreamClientScrcpy_start.value.removeActivityListener(handleActivityChange);
			StreamClientScrcpy_start.value.destroy();
			StreamClientScrcpy_start.value = null;
			store.commit('change_screen', false);
		}
		clearImeEvents();
	};
	//单个云手机续费
	const renewPhone = (Phone : any) => {
		const skip_value = { deviceId: [Phone.id], is_realphone: Phone.instances.is_realphone, tab: 'second' };
		router.push('/purches/' + encodeURIComponent(JSON.stringify(skip_value)));
	};
	//批量续费云手机
	const batchRenew = () => {
		const selected = phoneList.value.filter(phone => phone.checked);
		if (selected.length === 0) {
			ElMessage.warning('请先选择云手机');
			return;
		}
		const skip_value = { deviceId: selected.map(phone => phone.id), is_realphone: phoneList.value[0].instances.is_realphone, tab: 'second' };
		router.push('/purches/' + encodeURIComponent(JSON.stringify(skip_value)));
	};
	//购买云手机(跳转云手机页面)
	const addNewPhone = () => {
		router.push('/purches/0');
	};
	//重启云手机
	const restartPhone = () => {
		const requestData = { instance_id: currentPhone.value.id };
		const response = request.post('/containers/restart', requestData);
		const response2 = request.post('/containers/info', requestData);
		restartPhone_loading.value = true;
		restartPhone_loading_text.value = '云手机重启中,请稍等';
		closeOverlay(true);
		response.then(() => {
			var loading_val = setInterval(() => {
				response2.then((res2) => {
					if (res2.data.data.status == 1) {
						clearInterval(loading_val);
						setTimeout(() => {
							initPhone(currentPhone.value, 1000);
							restartPhone_loading.value = false;
						}, 6000);
					}
				});
			}, 1000);
		});
	};

	const shutdownPhone = () => {
		ElMessageBox.confirm(
			'一键新机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		)
			.then(async () => {
				const requestData = { instance_use_id: currentPhone.value.id };
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重启中,请稍等';
				closeOverlay(true);
				await request.post('/realphone/easy_recreate', requestData);
				await new Promise(resolve => setTimeout(resolve, 5000));
				await pollContainerInfo(currentPhone.value.id, {
					interval: 1000,
					maxAttempts: 60,
					onProgress: (attempt) => console.log(`轮询第 ${attempt} 次`)
				});
				await new Promise(resolve => setTimeout(resolve, 6000));
				initPhone(currentPhone.value, 1000);
				restartPhone_loading.value = false;
			})
			.catch(() => { })
	};

	// 右键菜单处理函数
	const handlePhoneContextMenu = (event: MouseEvent, phone: Phone) => {
		contextMenuRef.value?.show(event, phone.id, null);
	};

	const handleShowContextMenu = ({ event, phoneId, client }: any) => {
		contextMenuRef.value?.show(event, phoneId, client);
	};

	const handleContextRestart = async (phoneId: string) => {
		try {
			restartPhone_loading.value = true;
			restartPhone_loading_text.value = '云手机重启中,请稍等';
			await request.post('/containers/restart', { instance_id: phoneId });
			await pollContainerInfo(Number(phoneId), {
				interval: 1000,
				maxAttempts: 60
			});
			await new Promise(resolve => setTimeout(resolve, 6000));
			await fetchPhoneList();
			restartPhone_loading.value = false;
			ElMessage.success('云手机重启成功');
		} catch (error) {
			restartPhone_loading.value = false;
			console.error('重启失败:', error);
		}
	};

	const handleContextReset = async (phoneId: string) => {
		ElMessageBox.confirm(
			'重置云机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		).then(async () => {
			try {
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重置并重启中,请稍等';
				await request.post('/containers/batch_reset', { instance_id: phoneId });
				await pollContainerInfo(Number(phoneId), {
					interval: 1000,
					maxAttempts: 60
				});
				await new Promise(resolve => setTimeout(resolve, 6000));
				await fetchPhoneList();
				restartPhone_loading.value = false;
				ElMessage.success('云手机重置成功');
			} catch (error) {
				restartPhone_loading.value = false;
				console.error('重置失败:', error);
			}
		}).catch(() => {});
	};

	const handleContextOneKeyNew = async (phoneId: string) => {
		ElMessageBox.confirm(
			'一键新机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		).then(async () => {
			try {
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重启中,请稍等';
				await request.post('/realphone/easy_recreate', { instance_use_id: phoneId });
				await new Promise(resolve => setTimeout(resolve, 5000));
				await pollContainerInfo(Number(phoneId), {
					interval: 1000,
					maxAttempts: 60
				});
				await new Promise(resolve => setTimeout(resolve, 6000));
				await fetchPhoneList();
				restartPhone_loading.value = false;
				ElMessage.success('一键新机成功');
			} catch (error) {
				restartPhone_loading.value = false;
				console.error('一键新机失败:', error);
			}
		}).catch(() => {});
	};

	const handleContextChangeModel = (phoneId: string) => {
		const id = Number(phoneId);
		const phone = previewPhoneList.value.find(p => p.id === id) || phoneList.value.find(p => p.id === id);
		if (phone) {
			changeModelDialogRef.value?.show(
				String(phone.id),
				phone.instance_name || `云机${phone.id}`,
				phone.image_tag
			);
		}
	};

	const handleContextTransfer = (phoneId: string) => {
		const phone = phoneList.value.find(p => p.id === Number(phoneId));
		if (phone) {
			transferDialogRef.value?.show([phone]);
		}
	};

	const restart_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			const requestData = { instance_use_ids: selected_data.map(item => item.id) };
			request.post('/containers/batch_restart', requestData).then(() => {
				ElMessage.success('云手机重启中');
				fetchPhoneList();
			}).catch(() => { });
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};

	const reset_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			ElMessageBox.confirm(
				'重置云机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					const requestData = { instance_use_ids: selected_data.map(item => item.id) };
					request.post('/containers/batch_reset', requestData).then(() => {
						ElMessage.success('云手机重启中');
						fetchPhoneList();
					}).catch(() => { });
				})
				.catch(() => { })
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};
	//群体一键新机
	const shutdown_All_Phone = async () => {
		const selected_data = previewPhoneList.value.filter(phone => phone.checked);
		if (selected_data.length > 0) {
			ElMessageBox.confirm(
				'一键新机将清空云机内数据，是否确认重置?',
				'警告',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					const requestData = { instance_use_ids: selected_data.map(item => item.id) };
					request.post('/realphone/batch_easy_recreate', requestData).then(() => {
						ElMessage.success('云手机重启中');
						fetchPhoneList();
					}).catch(() => { });
				})
				.catch(() => { })
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};
	//更换机型弹窗根据安卓版本选中的云手机列表
	const handleSelectionChange = (val : any[]) => {
		android_selectedPhones.value = val;
	};

	//群体更换机型弹窗开关
	const change_phone_model_dialog_show = async (item : AndroidVersionGroup) => {
		try {
			const res = await request.get(`/realphone/list?android_version=${item.android_version}`);
			res.data.data.forEach((item : any, index : number) => {
				res.data.data[index] = { ...item, model: item.brand, id: index };
			});
			phone_type_list.value = res.data.data;
			current_android_phone_tableData.value = item.phones_arr;
			current_android_version.value = item.android_version;

			// 等待 DOM 更新
			await nextTick();

			// 自动勾选当前已选择的设备
			if (phoneTableRef.value) {
				// 先清除所有选择
				phoneTableRef.value.clearSelection();

				// 不再按真机类型过滤，保留当前已勾选的设备
				current_android_phone_tableData.value.forEach((row : Phone) => {
					if (row.checked) {
						phoneTableRef.value.toggleRowSelection(row, true);
					}
				});
			}

			// 最后再显示对话框
			change_phone_model_visible.value = true;
		} catch (error) {
			console.error('请求失败:', error);
		}
	};
	//把云手机列表按安卓版本进行分类处理
	const android_classify_phone = async () => {
		// 按安卓版本分组
		const groupedArray = previewPhoneList.value.reduce((result : any[], currentItem : any) => {
			const tag = currentItem.image_tag;
			let tagGroup = result.find((group : AndroidVersionGroup) => group.android_version === tag);

			if (!tagGroup) {
				tagGroup = {
					android_version: tag,
					phones_arr: []
				};
				result.push(tagGroup);
			}

			tagGroup.phones_arr.push(currentItem);
			return result;
		}, []);
		// 对分组进行排序：按安卓版本号（字符串转数字）
		groupedArray.sort((a : any, b : any) => {
			// 提取版本号数字，处理可能的小数点
			const versionA = parseFloat(a.android_version) || 0;
			const versionB = parseFloat(b.android_version) || 0;
			return versionB - versionA; // 降序排列（高版本在前）
		});
		// 对每个分组内的phones_arr进行排序：checked为true的在前
		groupedArray.forEach((group : any) => {
			group.phones_arr.sort((a : any, b : any) => {
				// 如果a.checked为true，b.checked为false，则a在前
				if (a.checked && !b.checked) return -1;
				// 如果a.checked为false，b.checked为true，则b在前
				if (!a.checked && b.checked) return 1;
				// 其他情况保持原顺序
				return 0;
			});
		});
		android_classify_phone_list.value = groupedArray;
		change_phone_model_dialog_show(android_classify_phone_list.value[0]);
	};
	// 添加一个安全的方法来处理 row-key
	const getRowKey = (row : Phone) => {
		if (!row) return 'empty-row-key';
		return row.instance_id || row.id || Math.random().toString();
	};
	//按照安卓品牌更换机型时 选择品牌
	const select_brands = (value : string) => {
		const foundItem = phone_type_list.value.find(item => item.brand === value);
		// 类型断言改为符合 ModelOption 类型
		select_model_list.value = (foundItem ? foundItem.models : []) as ModelOption[];
	}
	//群体更换机型方法
	const check_All_phone_type = async () => {
		if (!select_brand_value.value || !select_model_value.value) {
			ElMessage.warning('请先选择云机品牌和机型');
			return;
		}
		if (android_selectedPhones.value.length > 0) {
			const requestData = {
				model_id: select_model_value.value,
				instance_use_ids: android_selectedPhones.value.map(item => item.id),
				clear_data: reset_phone_data_checked.value ? 'true' : 'false'
			};
			restartPhone_loading.value = true;
			request.post('/realphone/batch_change_model', requestData).then(() => {
				ElMessage.success('云手机重启中');
				change_phone_model_visible.value = false
				fetchPhoneList();
			}).catch(() => { });
		} else {
			ElMessage.warning('请先勾选云手机');
		}
	};

	const pollRequest = async <T>(
		requestFn : () => Promise<any>,
		checkFn : (response : any) => boolean,
		options : { interval ?: number; maxAttempts ?: number; onProgress ?: (attempt : number, response : any) => void; } = {}
	) : Promise<T> => {
		const { interval = 5000, maxAttempts = 10, onProgress } = options;
		let attempts = 0;
		const poll = async () : Promise<T> => {
			attempts++;
			try {
				const response = await requestFn();
				if (onProgress) onProgress(attempts, response);
				if (checkFn(response)) return response;
				else if (attempts >= maxAttempts) throw new Error(`轮询达到最大次数 (${maxAttempts})`);
				else {
					await new Promise(resolve => setTimeout(resolve, interval));
					return poll();
				}
			} catch (error) {
				if (attempts >= maxAttempts) throw error;
				else {
					await new Promise(resolve => setTimeout(resolve, interval));
					return poll();
				}
			}
		};
		return poll();
	};

	const pollContainerInfo = (
		instanceId : number,
		options : { interval ?: number; maxAttempts ?: number; onProgress ?: (attempt : number, response : any) => void; } = {}
	) => {
		const requestFn = () => request.post('/containers/info', { instance_id: instanceId });
		const checkFn = (response : any) => response.data.data?.instances?.rtc_status === 1;
		return pollRequest(requestFn, checkFn, options);
	};
	//单云机重置
	const resetPhone = () => {
		ElMessageBox.confirm(
			'重置云机将清空云机内数据，是否确认重置?',
			'警告',
			{
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			}
		)
			.then(() => {
				const requestData = { instance_id: currentPhone.value.id };
				const response = request.post('/containers/batch_reset', requestData);
				const response2 = request.post('/containers/info', requestData);
				restartPhone_loading.value = true;
				restartPhone_loading_text.value = '云手机重置并重启中,请稍等';
				closeOverlay(true);
				response.then(() => {
					var loading_val = setInterval(() => {
						response2.then((res2) => {
							if (res2.data.data.status == 1) {
								clearInterval(loading_val);
								setTimeout(() => {
									initPhone(currentPhone.value, 1000);
									restartPhone_loading.value = false;
								}, 6000);
							}
						});
					}, 1000);
				});
			})
			.catch(() => { })
	};

	const change_phone_type = (type : any) => {
		request.get(`/realphone/list?android_version=${currentPhone.value.image_tag}`).then((res) => {
			res.data.data.forEach((item : any, index : any) => {
				res.data.data[index] = { ...item, model: item.brand, id: index };
			});
			phone_type_list.value = res.data.data;
			phone_type_cascader_show.value = true
		});
	};

	const check_phone_type = async (value : any) => {
		var requestData = {
			model_id: value[value.length - 1],
			instance_use_id: currentPhone.value.id
		};
		restartPhone_loading.value = true;
		restartPhone_loading_text.value = '云手机重启中,请稍等';
		phone_type_popoverRef.value?.hide()
		closeOverlay(true);
		try {
			await request.post('/realphone/change_model', requestData);
			await new Promise(resolve => setTimeout(resolve, 5000));
			await pollContainerInfo(currentPhone.value.id, {
				interval: 5000,
				maxAttempts: 10
			});
			setTimeout(() => {
				initPhone(currentPhone.value, 1000);
			}, 6000);
			restartPhone_loading.value = false;
		} catch (error) {
			restartPhone_loading.value = false;
			phone_type_popoverRef.value?.hide()
			throw error;
		}
	};

	const polling_containers_info = () => {
		const containers_info = { instance_id: currentPhone.value.id };
		request.post('/containers/info', containers_info).then((res2) => {
			if (res2.data.data.status == 1) {
				clearInterval(loading_phone_info.value);
				setTimeout(() => {
					initPhone(currentPhone.value, 1000);
					restartPhone_loading.value = false;
				}, 5000);
			}
		});
	};

	const handleResize = () => {
		windowWidth.value = window.innerWidth;
		if (windowWidth.value >= 800 && !showInfoPanel.value) {
			showInfoPanel.value = true;
		}
		if (window.innerWidth < 800) {
			elementWidth.value = '100%';
			elementWidthflag.value = false;
		} else {
			elementWidth.value = 'auto';
			elementWidthflag.value = true;
		}
	};

	const initPlayers = async (zoomsize : any) => {
		const { MsePlayer } = await import('@/app/player/MsePlayer');
		StreamClientScrcpy.registerPlayer(MsePlayer);
		const { WebCodecsPlayer } = await import('@/app/player/WebCodecsPlayer');
		StreamClientScrcpy.registerPlayer(WebCodecsPlayer);
		MsePlayer.resize(880, 1920, zoomsize, 5388608);
	};
	//根据当前电脑分辨率计算出当前云手机屏幕的缩放比例
	function setCloudPhoneZoom() {
		var zoomsize = 0.4
		var screen_width = window.screen.width
		if (screen_width > 1920) {
			zoomsize = 0.4 + (Math.floor((screen_width - 1920) / 96) * 0.01)
		} else if (screen_width < 1920) {
			zoomsize = 0.4 - (Math.floor((1920 - screen_width) / 96) * 0.01)
		} else {
			zoomsize = 0.4
		}
		return zoomsize;
	}
	onMounted(async () => {
		const zoom = setCloudPhoneZoom();
		await initPlayers(zoom);
		window.addEventListener('resize', handleResize);
		await fetchPhoneList();
		startPhoneListPolling();

		// 监听右键菜单事件
		eventBus.on('show-phone-context-menu', handleShowContextMenu);
	});

	onUnmounted(() => {
		if (StreamClientScrcpy_start.value) {
			StreamClientScrcpy_start.value.removeActivityListener(handleActivityChange);
			StreamClientScrcpy_start.value.destroy();
		}
		stopPhoneListPolling();
		window.removeEventListener('resize', handleResize);
		clearImeEvents();
		eventBus.off('show-phone-context-menu', handleShowContextMenu);
	});

	interface CommitMsg { type : 'commit'; text ?: string; }
	interface DeleteMsg { type : 'delete'; count : number; text ?: string; }
	interface ReplaceMsg { type : 'replace'; text ?: string; }
	type InputMsg = CommitMsg | DeleteMsg | ReplaceMsg;
	const imeRef = ref<HTMLInputElement | null>(null);
	const imeRef2 = ref<HTMLInputElement | null>(null);
	let lastSent = "";
	let isEventsBound = false;
	let keyInputListener : KeyEventListener | null = null;
	let isComposing = ref(false);
	function sendMsg(msg : InputMsg) : void {
		const client = StreamClientScrcpy_start.value;
		if (client?.mode === 'ws_room') {
			if (msg.type === 'delete') {
				const count = Math.max(1, msg.count || 1);
				for (let i = 0; i < count; i++) {
					client.sendBackspaceKey?.();
				}
			} else if (msg.text) {
				client.sendImeText?.(msg.text);
			}
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
			return;
		}
		const currentPhone_udid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = { udid: currentPhone_udid, text: msg.text };
		request.post('/containers/transfer_text', requestData).then(() => {
			if (!isComposing.value) {
				KeyInputHandler.setWebSocketEnabled(true);
			}
		}).catch(() => { });
	}
	const imeRef_focus = () => {
		if (store.state.Phone_Local_keyboard_flag) {
			imeRef.value?.focus()
		} else {
			imeRef2.value?.focus()
		}
	}
	const handleCompositionStart = (e : Event) => {
		const ev = e as CompositionEvent;
		isComposing.value = true;
		KeyInputHandler.setWebSocketEnabled(false);
		e.stopImmediatePropagation();
		e.preventDefault();
	};

	const handleCompositionEnd = (e : Event) => {
		const ev = e as CompositionEvent;
		const chineseText = ev.data?.trim();
		setTimeout(() => {
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}, 100);

		if (chineseText && store.state.Phone_Local_keyboard_flag && imeRef.value) {
			const msg : CommitMsg = { type: 'commit', text: chineseText };
			sendMsg(msg);
			imeRef.value.value = "";
			lastSent = "";
		}
	};

	const handleInput = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const inputEvent = e as InputEvent;
		const newValue = imeRef.value.value;

		if (isComposing.value) {
			return;
		}
		if (newValue.length > lastSent.length) {
			const newChars = newValue.slice(lastSent.length);
			const isWsRoom = StreamClientScrcpy_start.value?.mode === 'ws_room';

			for (const char of newChars) {
				if (char === '?' || char === '/') {
					sendSymbolAsText(char);
					continue;
				}
				if (char >= ' ' && char <= '~') {
					if (isWsRoom) {
						// ws_room 下统一走房间消息，直接下发到聚焦的输入框，不经 Gboard
						StreamClientScrcpy_start.value?.sendImeText?.(char);
					} else {
						KeyInputHandler.sendCharacter(char);
					}
					console.log('前端传递字符:', char, isWsRoom ? '(ws_room sendImeText)' : '(ws_scrcpy sendCharacter)');
				}
			}
			lastSent = newValue;
		}
		else if (newValue.length < lastSent.length) {
			lastSent = newValue;
		}
	};
	const sendSymbolAsText = (symbol : string) => {
		if (!currentPhone.value?.instances?.machine || !currentPhone.value?.instances?.adb_port) {
			ElMessage.error('云手机信息不完整，无法发送符号');
			return;
		}
		if (StreamClientScrcpy_start.value?.mode === 'ws_room') {
			StreamClientScrcpy_start.value.sendImeText?.(symbol);
			return;
		}
		const currentPhoneUdid = `${currentPhone.value.instances.machine.ip}:${currentPhone.value.instances.adb_port}`;
		const requestData = {
			udid: currentPhoneUdid,
			text: symbol
		};
		request.post('/containers/transfer_text', requestData)
			.then(() => { })
			.catch(() => { });
	};

	const handleKeyDown = (e : KeyboardEvent) => {
		if (!store.state.Phone_Local_keyboard_flag || isComposing.value) return;
		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'down', 0);
			return;
		}

		if (e.key === 'Backspace') {
			e.preventDefault();
			if (StreamClientScrcpy_start.value?.mode === 'ws_room') {
				StreamClientScrcpy_start.value.sendBackspaceKey?.();
			} else {
				KeyInputHandler.sendBackspaceKey();
			}
			return;
		}

		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'down', metaState);
		}
	};

	const handleKeyUp = (e : KeyboardEvent) => {
		if (isComposing.value || !store.state.Phone_Local_keyboard_flag) {
			e.stopPropagation();
			e.preventDefault();
			return;
		}

		if (e.key === 'CapsLock') {
			e.preventDefault();
			KeyInputHandler.sendKeyEvent(e.code, 'up', 0);
			return;
		}

		const functionKeys = [
			'Enter', 'Tab', 'Escape', 'ArrowUp', 'ArrowDown',
			'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
		];

		if (functionKeys.includes(e.key)) {
			e.preventDefault();
			const metaState = e.shiftKey ? 1 : 0;
			KeyInputHandler.sendKeyEvent(e.code, 'up', metaState);
		}
	};
	const handlePaste = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText) {
			const client : any = StreamClientScrcpy_start.value;
			if (client?.mode === 'ws_room') {
				// ws_room：注入到云机当前聚焦的输入框（IME 文本），与输入字符一致。
				// 注：不写入云机剪贴板，只粘贴。若要同时写剪贴板可另加 sendClipboard 调用。
				client.sendImeText?.(pastedText);
			} else {
				// ws_scrcpy 原生 SET_CLIPBOARD 会触发一次 paste 到聚焦输入框
				client?.sendMessage?.(CommandControlMessage.createSetClipboardCommand(pastedText));
			}
			imeRef.value.value = "";
		}
	};
	const handlePaste2 = (e : Event) => {
		if (store.state.Phone_Local_keyboard_flag || !imeRef2.value) return;
		const ev = e as ClipboardEvent;
		ev.preventDefault();
		const pastedText = ev.clipboardData?.getData('text');
		if (pastedText != "" && pastedText != undefined) {
			const client : any = StreamClientScrcpy_start.value;
			if (client?.mode === 'ws_room') {
				client.sendImeText?.(pastedText);
			} else {
				client?.sendMessage?.(CommandControlMessage.createSetClipboardCommand(pastedText));
			}
		}
	};

	const handleFocus = (e : Event) => {
		if (!store.state.Phone_Local_keyboard_flag || !imeRef.value) return;
		lastSent = imeRef.value.value;
	};

	const handleBlur = (e : Event) => {
		isComposing.value = false;
		KeyInputHandler.setWebSocketEnabled(true);
	};
	const bindImeEvents = () => {
		const inp = imeRef.value;
		if (!inp || !store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('input', handleInput);
		inp.addEventListener('keydown', handleKeyDown);
		inp.addEventListener('compositionstart', handleCompositionStart);
		inp.addEventListener('compositionend', handleCompositionEnd);
		inp.addEventListener('keyup', handleKeyUp);
		inp.addEventListener('paste', handlePaste);
		inp.addEventListener('focus', handleFocus);
		inp.addEventListener('blur', handleBlur);
		keyInputListener = {
			onKeyEvent: (message) => {
				if (ws.value && ws.value.readyState === WebSocket.OPEN) {
					ws.value.send(JSON.stringify(message));
				}
			}
		};
		KeyInputHandler.addEventListener(keyInputListener);
		isEventsBound = true;
		inp.focus();
		setTimeout(() => inp.focus(), 100);
	};
	const bindImeEvents2 = () => {
		const inp = imeRef2.value;
		if (!inp || store.state.Phone_Local_keyboard_flag || isEventsBound) return;
		inp.addEventListener('paste', handlePaste2);
		setTimeout(() => inp.focus(), 100);
	};
	const clearImeEvents = () => {
		const inp = imeRef.value;
		if (!inp || !isEventsBound) return;
		inp.removeEventListener('keydown', handleKeyDown);
		inp.removeEventListener('input', handleInput);
		inp.removeEventListener('compositionstart', handleCompositionStart);
		inp.removeEventListener('compositionend', handleCompositionEnd);
		inp.removeEventListener('keyup', handleKeyUp);
		inp.removeEventListener('paste', handlePaste);
		inp.removeEventListener('focus', handleFocus);
		inp.removeEventListener('blur', handleBlur);
		if (keyInputListener) {
			KeyInputHandler.removeEventListener(keyInputListener);
			keyInputListener = null;
		}

		isEventsBound = false;
		isComposing.value = false;
		lastSent = "";
		inp.value = "";
	};

	const clearImeEvents2 = () => {
		const inp = imeRef2.value;
		if (!inp) return;

		inp.removeEventListener('paste', handlePaste);

		inp.value = "";
	};

	watch(() => showOverlay.value, (isShow) => {
		if (isShow && store.state.Phone_Local_keyboard_flag) {
			bindImeEvents();
			clearImeEvents2()
		} else {
			clearImeEvents();
			bindImeEvents2()
		}
	}, { immediate: true });

	watch(() => store.state.Phone_Local_keyboard_flag, (isEnabled) => {
		const inp = imeRef.value;
		if (!inp) return;
		if (isEnabled && showOverlay.value) {
			bindImeEvents();
			clearImeEvents2()
		} else {
			clearImeEvents()
			bindImeEvents2();
			inp.value = "";
			isComposing.value = false;
			KeyInputHandler.setWebSocketEnabled(true);
		}
	}, { immediate: true });
	watch(() => store.state.orientation, (orientation) => {
		console.log('wahted orientation', orientation);
		if (StreamClientScrcpy_start.value) {
			StreamClientScrcpy_start.value.destroy();
			StreamClientScrcpy_start.value = null;
		}
		initPhone(currentPhone.value, 10)
	})
</script>

<style lang="less" scoped>
	.fun_options {
		p {
			margin: 0;
			padding: 10px 0 10px 20px;

			&:hover {
				background-color: rgb(235.9, 245.3, 255);
				color: #409eff;
				cursor: pointer;
			}
		}
	}
	:deep(.disabled-row) {
	    background-color: #f5f5f5;
	    color: #999;
	}
	
	:deep(.disabled-row .el-checkbox__inner) {
	    background-color: #f5f5f5;
	    border-color: #dcdfe6;
	    cursor: not-allowed;
	}
	
	:deep(.disabled-row .el-checkbox__input.is-disabled .el-checkbox__inner) {
	    background-color: #f5f5f5;
	    border-color: #dcdfe6;
	}
	
	:deep(.disabled-cell) {
	    color: #999 !important;
	}
	.android-tabs-header {
		display: flex;
		border-bottom: 1px solid #e0e0e0;
	}

	.android-tab-item {
		padding: 12px 24px;
		cursor: pointer;
		font-size: 14px;
		color: #666;
		transition: all 0.3s ease;
		position: relative;
	}

	.android-tab-item:hover {
		color: #3964fe;
	}

	.android-tab-item.active {
		color: #3964fe;
		font-weight: 500;
	}
	
	/* 底部蓝色边框 */
	.android-tab-item.active::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: -1px;
		width: 100%;
		height: 2px;
		background-color: #3964fe;
		border-radius: 1px 1px 0 0;
	}

	.phone-android-version-view {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;

		div {
			display: flex;
			align-items: center;
		}

		img {
			width: 20px !important;
			height: 20px !important;
		}
	}

	.android-version-view {
		margin-left: 10px;
		margin-right: 10px;
		border-top: 1px solid #999;
	}

	.android-version-view:nth-of-type(1) {
		border: none;
	}

	:deep(.function_btns .el-descriptions-item__content) {
		margin-left: 0 !important;
		padding-left: 0 !important;
	}

	.function_btns {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	:deep(.el-descriptions__body) {
		--el-descriptions-item-bordered-label-width: 0px;
	}

	.main_container {
		width: 100%;
		display: grid;
		grid-template-columns: repeat(8, 11.5%);
		justify-content: space-between;
		column-gap: 0.5%;
		row-gap: 2%;

		>div {
			min-width: 100%;
			height: 150px;

			img {
				width: 100%;
				height: auto;
				object-fit: contain;
			}
		}
	}

	/deep/ .phone-display {
		zoom: var(--zoomsize);
	}

	:deep(.phone-display .el-loading-spinner) {
		zoom: 2.4;
	}

	:deep(.more-box) {
		zoom: 2.4;
	}

	.left_box {
		background: #f0f3f5;

		:deep(.el-card__body) {
			padding: 10px;
		}
	}

	.phone-list-tabs {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 6px;
		margin-bottom: 10px;
		padding: 4px;
		background: #f2f6fc;
		border-radius: 8px;

		button {
			height: 30px;
			border: 0;
			border-radius: 6px;
			background: transparent;
			color: #606266;
			cursor: pointer;
			font-size: 13px;

			&.active {
				background: #ffffff;
				color: #0079f2;
				font-weight: 600;
				box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
			}
		}
	}

	.group-manage-panel {
		margin-bottom: 10px;
		border: 1px solid #ebeef5;
		border-radius: 8px;
		background: #ffffff;
		overflow: hidden;
	}

	.group-manage-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		padding: 10px;
		border-bottom: 1px solid #ebeef5;
	}

	.group-manage-title,
	.group-list-name,
	.assign-group-name {
		color: #303133;
		font-size: 13px;
		font-weight: 600;
	}

	.group-manage-subtitle,
	.group-list-count,
	.assign-group-desc,
	.group-empty {
		color: #909399;
		font-size: 12px;
	}

	.group-manage-actions {
		display: flex;
		gap: 6px;
		flex-shrink: 0;
	}

	.group-list-panel {
		min-height: 80px;
		max-height: 260px;
		overflow: auto;
	}

	.group-list-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
		padding: 10px;
		cursor: pointer;
		border-bottom: 1px solid #f0f2f5;

		&:last-child {
			border-bottom: 0;
		}

		&:hover {
			background: #f7fbff;
		}
	}

	.group-empty {
		padding: 18px 0;
		text-align: center;
	}

	.assign-group-tip {
		margin-bottom: 10px;
		color: #606266;
	}

	.assign-group-toolbar {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 8px;
	}

	.assign-group-list {
		max-height: 360px;
		overflow: auto;
		border: 1px solid #ebeef5;
		border-radius: 8px;
	}

	.assign-group-item {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 10px 12px;
		cursor: pointer;
		border-bottom: 1px solid #f0f2f5;

		&:last-child {
			border-bottom: 0;
		}

		&:hover {
			background: #f7fbff;
		}
	}

	.assign-group-info {
		min-width: 0;
	}

	.assign-group-name {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.select-all {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.compact-rectangle .logo {
		font-size: 20px;
		font-weight: bold;
		padding: 20px;

	}

	.compact-rectangle .phone_name_box {
		display: flex;
		justify-content: flex-end;
		align-items: center;

		input {
			width: 80%;
			height: 20px;
			margin-bottom: 10px;
			border: none;
			border-bottom: 1px solid #aaa;
		}

	}

	.header-bar {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #f5f7fa;
		padding: 10px 20px;
		border-bottom: 1px solid #ebeef5;
	}

	.top-right-buttons {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
	}

	.text-center {
		text-align: center;
		margin-top: 10px;
	}

	.mt-3 {
		margin-top: 15px;
	}

	.overlay-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 2000;
		display: flex;
		justify-content: flex-end;
	}

	.overlay-container {
		height: 100%;
		background: white;
		position: relative;
	}

	.close-icon {
		position: absolute;
		top: 20px;
		right: 20px;
		font-size: 24px;
		cursor: pointer;
		z-index: 2001;
	}

	.overlay-content {
		display: flex;
		height: 100%;
	}

	.phone-display {
		flex: 1;
		padding: 20px;
		background: #f5f7fa;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		position: relative;
		overflow-y: auto;
	}

	/deep/ .device-view {
		display: flex !important;
		flex-direction: row-reverse;
		flex-wrap: nowrap !important;
	}

	/deep/ .control-buttons-list {
		svg {
			width: 84px;
			height: 84px;

			&:hover {
				cursor: pointer;
			}
		}
	}

	.phone-info {
		width: 350px;
		background: #fff;
		border-radius: 4px;
		padding: 0;
		overflow: hidden;
		margin: 0 20px;

		h3 {
			margin: 0;
			padding: 16px;
			color: #303133;
			font-size: 16px;
			font-weight: 600;
			border-bottom: 1px solid #dcdfe6;
		}
	}

	.info-container {
		display: flex;
		flex-direction: column;
	}

	.info-row {
		display: flex;
		align-items: stretch;
		border-bottom: 1px solid #dcdfe6;

		&:last-child {
			border-bottom: none;
		}
	}

	.info-label {
		width: 100px;
		padding: 12px;
		color: #606266;
		font-size: 14px;
		font-weight: 500;
		flex-shrink: 0;
		background-color: #f5f7fa;
		border-left: 1px solid #dcdfe6;
		border-right: 1px solid #dcdfe6;
		display: flex;
		align-items: center;
	}

	.info-value {
		flex: 1;
		padding: 12px;
		color: #303133;
		font-size: 14px;
		display: flex;
		align-items: center;
		border-right: 1px solid #dcdfe6;
	}

	.status-tag {
		display: inline-block;
		padding: 0 10px;
		height: 24px;
		line-height: 24px;
		font-size: 12px;
		border-radius: 4px;
		box-sizing: border-box;
		white-space: nowrap;

		&.running {
			background-color: #f0f9eb;
			color: #67c23a;
			border: 1px solid #e1f3d8;
		}

		&.stopped {
			background-color: #fef0f0;
			color: #f56c6c;
			border: 1px solid #fde2e2;
		}

		&.offline {
			background-color: #fef0f0;
			color: #f56c6c;
			border: 1px solid #fde2e2;
		}

		&.restarting {
			background-color: #fdf6ec;
			color: #e6a23c;
			border: 1px solid #faecd8;
		}
	}

	.action-row {
		box-sizing: border-box;
		padding: 10px 0;
		border-left: 1px solid #dcdfe6;
		border-right: 1px solid #dcdfe6;
		border-bottom: 1px solid #dcdfe6;
	}

	.action-buttons {
		padding: 16px;
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}

	@media (max-width: 800px) {
		.phone-info {
			position: absolute;
			right: 0;
			top: 0;
			bottom: 0;
			width: 350px;
			background: white;
			box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
			transform: translateX(0);
			z-index: 1;

			&.hidden {
				transform: translateX(100%);
			}
		}

		.info-row {
			flex-direction: column;
			align-items: flex-start;
			gap: 4px;
		}

		.info-label {
			width: 100%;
		}

		.action-row {
			flex-direction: column;
		}

		.action-row .el-button {
			width: 100%;
			margin-bottom: 8px;
		}
	}

	@media (max-width: 500px) {
		.phone-display {
			min-width: 100%;
		}
	}

	.info-toggle-btn {
		position: absolute;
		top: 50%;
		right: 10px;
		transform: translateY(-50%);
		z-index: 2;
	}

	.slide-fade-enter-active {
		transition: all 0.3s ease-out;
	}

	.slide-fade-leave-active {
		transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter-from,
	.slide-fade-leave-to {
		opacity: 0;
		transform: translateX(100%);
	}

	.compact-container {
		display: flex;
		gap: 4px;
		padding: 0 10px;
	}

	.compact-wrapper {
		width: 50%;
		padding: 0 2px;
	}

	.compact-rectangle {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0;
		background: #ffffff;
		border-radius: 8px;
		border: 1px solid #ebeef5;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
		cursor: pointer;
		transition: all 0.2s;
		overflow: hidden;
		padding: 10px;
		box-sizing: border-box;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
		}
	}

	.compact-image-container {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		background: #ffffff;
		padding: 0;
		margin: 0;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	/* 云机卡片 v-loading 覆盖：文字白色、整体居中、不被裁掉 */
	:deep(.compact-image-container) .el-loading-mask {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	:deep(.compact-image-container) .el-loading-spinner {
		position: static;
		top: auto;
		margin-top: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 6px;
	}
	:deep(.compact-image-container) .el-loading-spinner .el-loading-text {
		color: #ffffff;
		font-size: 12px;
		line-height: 1.2;
		margin: 0;
		white-space: nowrap;
	}

	.compact-label {
		padding: 6px;
		text-align: center;
		font-size: 12px;
		color: #333;
		border-top: 1px solid #ebeef5;
	}

	.compact-add-btn {
		width: 90%;
		padding: 8px 12px;
		font-size: 12px;
		color: #409EFF;
		border-color: #409EFF;
		background-color: #ffffff;

		&:hover {
			color: #ffffff;
			background-color: #409EFF;
		}
	}
</style>
